
import Vue from "vue"

export default Vue.extend({
  props: {
    name: { type: String, required: true },
  },

  computed: {
    path (): string {
      return `/icons/${this.name}.svg`
    },
  },
})
